import { useRef } from "react"
import { useBuiltinFieldRules } from "source/shared/hooks/useBuiltinFieldRules"
import { Select } from "source/shared/components"
import { Icon } from "source/shared/components"

type CampusSelectProps = {
  value: string
  onChange: (value: string) => void
  campuses: Array<{ id: string; attributes: { name: string } }>
}

export function CampusSelect({ value, onChange, campuses }: CampusSelectProps) {
  const campusOptions = campuses.map((c) => ({
    label: c.attributes.name,
    value: c.id,
  }))

  const { campus: campusEditingRule } = useBuiltinFieldRules()

  const valueRef = useRef(value)

  const disabled =
    campusEditingRule === "view" ||
    !!(campusEditingRule === "add_if_blank" && valueRef)

  const handleChange = (e: { target: { value: string } }) =>
    onChange(e.target.value)

  return (
    <>
      <div className="d-f">
        <label htmlFor="campus">Campus</label>
        <span className="screen-reader-text">Campus</span>
        {disabled && <Icon symbol="general#lock" className="fs-2 pl-1 pt-1" />}
      </div>
      <Select
        disabled={disabled}
        name="campus"
        value={value}
        onChange={handleChange}
        options={[{ label: "Select...", value: "" }, ...campusOptions]}
      />
    </>
  )
}
